import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';

const SectionStats = ({ header, items, containerClasses, backgroundColor = '#F3F5F6' }) => {
  const classes = `px-8 py-14 md:px-24 xl:px-36 2xl:px-60 lg:py-10 w-full ${containerClasses || ''}`;

  return (
    <div className={classes} style={{ backgroundColor }}>
      {header && (
        <h2 className="text-3xl lg:text-4xl font-bold text-center text-[#1C2938] mb-10">
          {parse(header)}
        </h2>
      )}

      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8 md:gap-12">
          {items.map((item, index) => (
            <div
              key={index}
              className="flex flex-row items-center md:flex-col md:items-center md:text-center gap-10 md:gap-0"
            >
              <div className="order-1 md:order-none shrink-0">
                {item.image?.url && (
                  <div className="md:mb-4 flex items-center justify-center">
                    <img
                      src={item.image.url}
                      alt={item.body}
                      className="h-[72px] w-[72px] object-contain"
                    />
                  </div>
                )}
              </div>
              <div className="order-2 md:order-none">
                <p className="text-4xl font-semibold text-[#18293A]">
                  {parse(item.header)}
                </p>
                <p className="text-sm text-[#18293A] mt-3">
                  {parse(item.body)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

SectionStats.propTypes = {
  header: PropTypes.string,
  containerClasses: PropTypes.string,
  backgroundColor: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string,
      }),
      header: PropTypes.string.isRequired,
      body: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default SectionStats;
